import PropTypes from 'prop-types';
import useReveal from '../../hooks/useReveal';
import styles from './gradientLines.module.scss';

function GradientLines({ animate = true }) {
  // Draw the lines in once the banner scrolls into view. When animation is
  // disabled, the lines render in their final (visible) state immediately —
  // `.animate` is what reveals them, so it's applied statically in that case.
  const [ref, inView] = useReveal({ threshold: 0.1 });
  const animateClass = !animate || inView ? styles.animate : '';

  return (
    <div
      ref={animate ? ref : undefined}
      className={`${styles.gradientLines} ${animateClass}`.trim()}
    >
      <div className={styles.gradientLine1} />
      <div className={styles.gradientLine2} />
      <div className={styles.gradientLine3} />
      <div className={styles.gradientLine4} />
    </div>
  );
}

GradientLines.propTypes = {
  animate: PropTypes.bool,
};

export default GradientLines;
